import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { IntlService } from '@frontend/vanilla/core';

import { NextRaces } from '../models/tracking';

@Injectable({
    providedIn: 'root',
})
export class HorseRacingTrackingService {
    constructor(
        private trackingService: TrackingService,
        private sitecore: Sitecore,
        private intlService: IntlService,
    ) {}

    trackRaceView(race: WinGameFixture, trackingPosition: string, value?: string): void {
        const viewFullRace = this.sitecore.horseRacing.nextThreeRaces.ViewFullRace;
        let CategoryEvent = '';
        let eventDetails = '';
        if (value === viewFullRace) {
            CategoryEvent = 'sports lobby widgets';
            eventDetails = 'view full race';
        } else {
            CategoryEvent = 'sports lobby grid widgets';
            eventDetails = 'sport event';
        }
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: CategoryEvent,
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: race.name.value,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: trackingPosition,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'next races',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetails,
            eventId: race.id,
            sportId: race.sport.id,
            [trackingConstants.COMPONENT_MODULE_NAME]: 'NextRaces',
            [trackingConstants.COMPONENT_MODULE_POSITION]: this.intlService.formatDate(race.startDate, 'HH:mm') || '',
            [trackingConstants.COMPONENT_PAGE_LAYOUT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_MODULE_CUSTOM_NAME]: race.name.value,
            [trackingConstants.COMPONENT_MODULE_SOURCE]: NOT_APPLICABLE,
        });
    }

    trackArrows(event: string): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'sports lobby grid widgets',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'next races',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: event,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    trackNextRaces(fixtures: WinGameFixture[]) {
        let position = 0;
        const races = fixtures.map((fixture) => {
            const trackDetails = {
                [trackingConstants.COMPONENT_MODULE_NAME]: 'NextRaces',
                [trackingConstants.COMPONENT_MODULE_POSITION]: this.intlService.formatDate(fixture.startDate, 'HH:mm') || '',
                [trackingConstants.COMPONENT_CONTENT_POSITION]: position++,
                [trackingConstants.COMPONENT_PAGE_LAYOUT]: NOT_APPLICABLE,
                [trackingConstants.COMPONENT_MODULE_CUSTOM_NAME]: fixture.name.value,
                [trackingConstants.COMPONENT_MODULE_SOURCE]: NOT_APPLICABLE,
            } as NextRaces;

            return trackDetails;
        });

        this.trackingService.track(trackingConstants.SHOW_NEXTRACES, {
            [trackingConstants.SHOW_NEXTRACES]: races,
        });
    }

    trackfilter(filterType: string): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'sports lobby widgets',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'filter',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'next races',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: filterType,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }
}
